import {
  AdobeTracking,
  ComponentTrackingPath,
  DefaultLinkClickData,
  NavigationService,
  SanitizedComponentTrackingPath,
  TrackingService,
} from '@repo/roche-xx-shared';

export const trackTabClick = (_, tabName: string, componentPath: ComponentTrackingPath) => {
  TrackingService.push({
    event: 'tabs_click',
    component_name: 'roche-accordion-tabs',
    value: tabName,
  });

  const baseType = 'accordion-tab';
  const adobeTrackingData: DefaultLinkClickData = {
    name: `${baseType}|${tabName}`,
    innerText: tabName,
    url: NavigationService.getCurrentPagePath(),
    position: SanitizedComponentTrackingPath(componentPath),
    type: baseType,
    socialMedia: '',
    socialInteraction: '',
  };

  AdobeTracking(adobeTrackingData, 'defaultLinkClick');
};

export const trackAccordionToggle = (_, panelName: string, componentPath: ComponentTrackingPath) => {
  TrackingService.push({
    event: 'accordion_click',
    component_name: 'roche-accordion-tabs',
    value: panelName,
  });

  const baseType = 'accordion-tab';
  const adobeTrackingData: DefaultLinkClickData = {
    name: `${baseType}|${panelName}`,
    innerText: panelName,
    url: NavigationService.getCurrentPagePath(),
    position: SanitizedComponentTrackingPath(componentPath),
    type: baseType,
    socialMedia: '',
    socialInteraction: '',
  };

  AdobeTracking(adobeTrackingData, 'defaultLinkClick');
};
